
import { StreamingStateEnum } from '@/data/webrtc-enums';
import { makeAutoObservable } from 'mobx';


export class StreamingStore {
    streamingState = StreamingStateEnum.WebRtcDisconnected;
    streamer : any = null;
    listResponseListener: any = [];
    onStateChanged: (state: StreamingStateEnum) => void = undefined;

    constructor() {
        makeAutoObservable(this);
    }
    

    connect() {
        this.streamer.connect();
    }

    startStreaming() {
        this.streamer?.play();
    }

    setStreamer(client: any) {
        this.streamer = client;
    }

    setStreamingState(streamingState: StreamingStateEnum) {
        this.streamingState = streamingState;
    }

    sendWebRtcMessage(descriptor: string) {
        console.log(`Send Msg: ${JSON.stringify(descriptor)}`);
        this.streamer.emitUIInteraction(descriptor);
    }

    addResponseEventListener(name: string, responseFunction: string) {
        this.streamer.addResponseEventListener(name, responseFunction);
    }

    setListenerResponseListener(list: any) {
        this.listResponseListener = list;
    }
}